/**
 * 结算设置
 */
import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import styles from "./modal.module.scss";
import http from "@/assets/api/http";
import {
    Modal,
    message,
    Form,
    InputNumber,
    Typography,
    Button,
    Radio,
} from "antd";
import * as apis from "@/apis/system/finance.js";

import {PlusCircleOutlined, MinusCircleOutlined} from "@ant-design/icons";

const {Text} = Typography;

function SettleSetting(props) {
    const [type, setType] = useState(1); // 0: 按距离 1:统一比例
    const [loading, setLoading] = useState(false);
    const [riderRatio, setRiderRatio] = useState();

    const autoId = useRef(1);
    const [list, setList] = useState([
        {key: 1, distance: null, riderRatio: null},
    ]);

    useEffect(() => {
        setRiderRatio(props.companyFinancialBaseInfo.riderRatio);
        const detail = props.companyFinancialBaseInfo;
        let feeData = JSON.parse(detail.feeJson || '[]') || [];
        if (feeData.length > 0) {
            feeData = feeData.map((v) => ({
                key: v.key,
                distance: v.distance / 1000,
                riderRatio: v.riderRatio,
            }));
            feeData.sort((a, b) => a.key - b.key);
            let lastItem = feeData[feeData.length - 1] || {};
            autoId.current = parseInt(lastItem.key);
            setList(feeData);
            setType(0);
        } else {
            setType(1);
            setList([{key: 1, distance: null, riderRatio: null}]);
        }
    }, []);

    const onTypeChange = (e) => {
        let val = e.target.value;
        setType(val);
    };

    const onInputChange = (val, item, type) => {
        let _list = list.map((v) => {
            if (v.key == item.key) {
                v[type] = val;
            }
            return v;
        });
        setList(_list);
    };

    const onAdd = () => {
        if (type == 1) {
            return false;
        }
        let _list = [...list];
        autoId.current += 1;
        _list.push({
            key: autoId.current,
            distance: null,
            riderRatio: null,
        });
        setList(_list);
    };

    const onDelete = (item) => {
        if (type == 1) {
            return false;
        }
        let _list = list.filter((v) => v.key != item.key);
        setList(_list);
    };

    const onCancel = () => {
        props.onCancel();
    };

    const onConfirm = () => {

        let formData = {
            sourceId: props.companyFinancialBaseInfo.financialId,
        };
        if (type == 1) {
            if (!riderRatio && riderRatio !== 0) {
                message.error("请输入统一收益比例！");
                return false;
            }
            formData.riderRatio = riderRatio;
        } else {
            let status = true;
            list.forEach((v) => {
                if (!v.distance || isNaN(parseFloat(v.riderRatio))) {
                    status = false;
                }
            });
            if (!status) {
                message.error("请完善公里数、比例设置！");
                return false;
            }
            formData.riderRatio = 0;
            formData.baseFee = list.map((v) => {
                let _v = {...v};
                _v.distance = _v.distance * 1000;
                return _v;
            });
        }
        apis.setCompanyRiderRatioV2(formData)
            .then((res) => {
                message.success("设置成功");
                props.onOk();
            })
            .catch((err) => {
                message.error(err.message);
            });
    };

    return (
        <Modal
            width={600}
            bodyStyle={{padding: 0}}
            centered
            title="结算设置"
            open={true}
            onCancel={onCancel}
            onOk={onConfirm}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}>
            <div className={styles.container}>
                <h2>场景：当配送单归属当前运营公司且配送骑手为众包骑手时</h2>
                <div className={styles.radioBox}>
                    <Radio.Group onChange={onTypeChange} value={type}>
                        <Radio value={1}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                <span>按统一收益设置 </span>
                                <InputNumber
                                    disabled={type == 0}
                                    addonAfter="%"
                                    style={{width: "120px", marginLeft: "5px"}}
                                    value={riderRatio}
                                    precision={2}
                                    min={0}
                                    max={100}
                                    placeholder="请输入"
                                    onChange={(e) => {
                                        setRiderRatio(e);
                                    }}
                                />
                            </div>
                        </Radio>
                        <Radio style={{marginLeft: "20px"}} value={0}>
                            按里程远近设置
                        </Radio>
                    </Radio.Group>
                </div>
                <div
                    className={`${styles.mileageBox} ${
                        type == 1 ? styles.disabled : ""
                    }`}>
                    {list.map((v, k) => (
                        <dl key={v.key}>
                            <dt>
                                <span
                                    className={styles.text}
                                    style={{
                                        width: "70px",
                                        textAlign: "right",
                                        display: "inline-block",
                                    }}>
                                    {k > 0 ? "里程增加至" : "0公里至"}
                                </span>
                                <InputNumber
                                    disabled={type == 1}
                                    min={1}
                                    max={100}
                                    precision={1}
                                    className={styles.input}
                                    value={v.distance}
                                    onChange={(val) => {
                                        onInputChange(val, v, "distance");
                                    }}
                                />
                                <span className={styles.text}>
                                    公里，众包骑手配送费按
                                </span>
                                <InputNumber
                                    disabled={type == 1}
                                    min={0}
                                    max={99.99}
                                    precision={2}
                                    className={styles.input}
                                    value={v.riderRatio}
                                    onChange={(val) => {
                                        onInputChange(val, v, "riderRatio");
                                    }}
                                />
                                <span className={styles.text}>%计算；</span>
                            </dt>
                            <dd>
                                {k > 0 ? (
                                    <MinusCircleOutlined
                                        className={styles.btn}
                                        onClick={() => {
                                            onDelete(v);
                                        }}
                                    />
                                ) : (
                                    <PlusCircleOutlined
                                        className={styles.btn}
                                        onClick={onAdd}
                                    />
                                )}
                            </dd>
                        </dl>
                    ))}
                </div>

                <div className={styles.bottomTips}>
                    <p>
                        骑手收益 = (配送费(不含小费) - 平台服务费) * 显示比例 +
                        小费
                    </p>
                </div>
            </div>
        </Modal>
    );
}

SettleSetting.propTypes = {
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    companyFinancialBaseInfo: PropTypes.object,
};
export default SettleSetting;
